var _filter, _filter2, _marker, _marker2, _marker3, _rect, _circle, _circle2, _circle3, _text, _text2, _g, _g2, _g3, _path, _path2, _path3, _path4, _rect2, _text3, _rect3, _text4, _rect4, _text5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodeflowIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 640",
    width: 1200,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f8fafc"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guiGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ecfdf5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#d1fae5"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodfloGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fff7ed"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ffedd5"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloudGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#eff6ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#dbeafe"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guiHeader",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#34d399"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#059669"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodfloHeader",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fb923c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ea580c"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloudHeader",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#60a5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2563eb"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "cardShadow",
    x: "-8%",
    y: "-8%",
    width: "116%",
    height: "116%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 16,
    floodColor: "#0f172a",
    floodOpacity: 0.08
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "softGlow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "over"
  }))), _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "arrowGreen",
    markerWidth: 12,
    markerHeight: 12,
    refX: 10,
    refY: 4,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,8 L10,4 z",
    fill: "#059669"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "arrowBlue",
    markerWidth: 12,
    markerHeight: 12,
    refX: 10,
    refY: 4,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,8 L10,4 z",
    fill: "#2563eb"
  }))), _marker3 || (_marker3 = /*#__PURE__*/React.createElement("marker", {
    id: "arrowOrange",
    markerWidth: 12,
    markerHeight: 12,
    refX: 10,
    refY: 4,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,8 L10,4 z",
    fill: "#ea580c"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 640,
    fill: "url(#bgGrad)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 180,
    fill: "#ecfdf5",
    fillOpacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1080,
    cy: 520,
    r: 200,
    fill: "#dbeafe",
    fillOpacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 80,
    r: 150,
    fill: "#fff7ed",
    fillOpacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 54,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 28,
    fontWeight: 700,
    fill: "#0f172a",
    textAnchor: "middle"
  }, "Shared Automation Architecture")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 84,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fill: "#64748b",
    textAnchor: "middle"
  }, "NodFlo independently extends both GUIBuilder and CloudView")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70, 140)",
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 380,
    rx: 20,
    fill: "url(#guiGrad)",
    stroke: "#a7f3d0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 72,
    rx: 20,
    fill: "url(#guiHeader)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 52,
    width: 280,
    height: 20,
    fill: "url(#guiHeader)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 28,
    height: 28,
    rx: 7,
    fill: "#ffffff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 41,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fill: "#ffffff",
    textAnchor: "middle"
  }, "\u25C8"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 42,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#ffffff"
  }, "GUIBuilder"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 96)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 44,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.85,
    stroke: "#a7f3d0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#065f46",
    textAnchor: "middle"
  }, "HMI Designer")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 150)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 44,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.85,
    stroke: "#a7f3d0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#065f46",
    textAnchor: "middle"
  }, "GUIBuilder Player")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 204)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 44,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.85,
    stroke: "#a7f3d0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#065f46",
    textAnchor: "middle"
  }, "Read / Write Tags")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 258)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 44,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.85,
    stroke: "#a7f3d0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#065f46",
    textAnchor: "middle"
  }, "Live Widgets")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 312)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 44,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.85,
    stroke: "#a7f3d0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#065f46",
    textAnchor: "middle"
  }, "Animations"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 44,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.85,
    stroke: "#a7f3d0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#065f46",
    textAnchor: "middle"
  }, "Alarms"))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(460, 140)",
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 380,
    rx: 20,
    fill: "url(#nodfloGrad)",
    stroke: "#fdba74",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 72,
    rx: 20,
    fill: "url(#nodfloHeader)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 52,
    width: 280,
    height: 20,
    fill: "url(#nodfloHeader)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 28,
    height: 28,
    rx: 7,
    fill: "#ffffff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 41,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fill: "#ffffff",
    textAnchor: "middle"
  }, "\u2699"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 42,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#ffffff"
  }, "NodFlo"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 96)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 38,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.9,
    stroke: "#fdba74",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Workflow Engine")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 144)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 38,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.9,
    stroke: "#fdba74",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Event Processing")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 192)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 38,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.9,
    stroke: "#fdba74",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "JavaScript")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 240)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 38,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.9,
    stroke: "#fdba74",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Conditions"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(122, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 38,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.9,
    stroke: "#fdba74",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Timers"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 288)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 38,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.9,
    stroke: "#fdba74",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "MQTT"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(122, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 38,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.9,
    stroke: "#fdba74",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Database"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 336)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 38,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.9,
    stroke: "#fdba74",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "REST API"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(122, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 38,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.9,
    stroke: "#fdba74",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Logic Execution"))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(850, 140)",
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 380,
    rx: 20,
    fill: "url(#cloudGrad)",
    stroke: "#93c5fd",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 72,
    rx: 20,
    fill: "url(#cloudHeader)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 52,
    width: 280,
    height: 20,
    fill: "url(#cloudHeader)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 28,
    height: 28,
    rx: 7,
    fill: "#ffffff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 41,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fill: "#ffffff",
    textAnchor: "middle"
  }, "\u2601"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 42,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#ffffff"
  }, "CloudView"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 96)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 44,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.85,
    stroke: "#93c5fd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#1e3a8a",
    textAnchor: "middle"
  }, "MQTT Broker")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 150)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 44,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.85,
    stroke: "#93c5fd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#1e3a8a",
    textAnchor: "middle"
  }, "REST API")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 204)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 44,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.85,
    stroke: "#93c5fd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#1e3a8a",
    textAnchor: "middle"
  }, "Device Management")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 258)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 44,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.85,
    stroke: "#93c5fd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#1e3a8a",
    textAnchor: "middle"
  }, "Dashboards")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 312)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 44,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.85,
    stroke: "#93c5fd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 600,
    fill: "#1e3a8a",
    textAnchor: "middle"
  }, "Historical Data"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(122, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 44,
    rx: 10,
    fill: "#ffffff",
    fillOpacity: 0.85,
    stroke: "#93c5fd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#1e3a8a",
    textAnchor: "middle"
  }, "Remote Monitoring"))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M460 240 C420 240, 390 220, 350 220",
    stroke: "#059669",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#arrowGreen)",
    strokeLinecap: "round",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "8,8;16,8;8,8",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M350 400 C390 400, 420 420, 460 420",
    stroke: "#059669",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#arrowGreen)",
    strokeLinecap: "round",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "8,8;16,8;8,8",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M740 240 C780 240, 810 220, 850 220",
    stroke: "#2563eb",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#arrowBlue)",
    strokeLinecap: "round",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "8,8;16,8;8,8",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M850 400 C810 400, 780 420, 740 420",
    stroke: "#2563eb",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#arrowBlue)",
    strokeLinecap: "round",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "8,8;16,8;8,8",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 288,
    width: 90,
    height: 24,
    rx: 12,
    fill: "#ffffff",
    stroke: "#059669",
    strokeWidth: 1,
    opacity: 0.95
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 415,
    y: 304,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#059669",
    textAnchor: "middle"
  }, "Tag Exchange")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 288,
    width: 90,
    height: 24,
    rx: 12,
    fill: "#ffffff",
    stroke: "#2563eb",
    strokeWidth: 1,
    opacity: 0.95
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 785,
    y: 304,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#2563eb",
    textAnchor: "middle"
  }, "Device Data")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 560,
    width: 900,
    height: 56,
    rx: 12,
    fill: "#f1f5f9",
    stroke: "#e2e8f0",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 593,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fill: "#334155",
    textAnchor: "middle"
  }, "NodFlo is the shared workflow automation engine that independently extends both GUIBuilder and CloudView.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeflowIntegration);
export default __webpack_public_path__ + "static/media/nodeflow_integration.5702fa79feeed158f099486be8d44650.svg";
export { ForwardRef as ReactComponent };